module.exports = __webpack_public_path__ + "static/media/dc-monitor.bb83c25e.svg";